import React, { useState, useCallback } from 'react';
import {
  createStyles,
  FormControl,
  InputAdornment,
  makeStyles,
  TextField,
} from '@material-ui/core';
import { debounce } from 'lodash';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(() => {
  return createStyles({
    search: {
      margin: '0',
      width: '400px',
    },
  });
});

export interface SearchInputProps {
  handleSearch: (searchText: string) => void;
  placeholder: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ placeholder, handleSearch }) => {
  const { search } = useStyles();

  const [searchValue, setSearchValue] = useState('');

  const debouncedHandleSearch = useCallback(debounce(handleSearch, 300), [handleSearch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newSearchValue = event.target.value;

    setSearchValue(newSearchValue);
    debouncedHandleSearch(newSearchValue);
  };

  return (
    <div id="app">
      <FormControl className={search}>
        <TextField
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          onChange={handleChange}
          placeholder={placeholder}
          size="small"
          value={searchValue}
          variant="outlined"
        />
      </FormControl>
    </div>
  );
};

export default SearchInput;
